import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";
import { Badge, CircularProgress, IconButton, Paper, Stack, Tooltip, Typography } from "@mui/material";
import ArtifactAgentAvatar from "./ArtifactAgentAvatar";

interface Props {
  isRunning: boolean;
  hasUnseenUpdate: boolean;
  onExpand: () => void;
}

const ArtifactAgentCollapsedHeader = ({ isRunning, hasUnseenUpdate, onExpand }: Props) => (
  <Paper variant="outlined" sx={{ width: 56, height: "100%" }}>
    <Stack spacing={1.75} sx={{ alignItems: "center", py: 1.5 }}>
      <Tooltip title="Expand" placement="left">
        <IconButton aria-label="Expand the assistant" onClick={onExpand}>
          <KeyboardArrowLeftRoundedIcon />
        </IconButton>
      </Tooltip>
      <Badge variant="dot" color="info" overlap="circular" invisible={isRunning || !hasUnseenUpdate}>
        <ArtifactAgentAvatar size="medium" />
      </Badge>
      {isRunning && <CircularProgress size={16} color="secondary" />}
      <Typography variant="h6" sx={{ writingMode: "vertical-rl", whiteSpace: "nowrap" }}>
        AI Assistant
      </Typography>
    </Stack>
  </Paper>
);

export default ArtifactAgentCollapsedHeader;
